module.exports = __webpack_public_path__ + "static/img/28.58c9739.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/28.jpg
// module id = NHmP
// module chunks = 16